import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { localizedStrings } from 'root/lib/l10n/l10n';
import Audio from 'root/lib/Audio';
import audio from 'a/hub/assets/audio/logOut';
import sfx from 'a/hub/assets/sfx/logOut';
import { useSelector } from 'react-redux';
import { getLocalization } from 'root/activities/selectors/languageSelectors';

import SessionModal from './SessionModal';

const MapLogOutModal = ({ onLogout, onCancel }) => {
  const localization = useSelector(getLocalization);

  const logoutSfx = new Audio(sfx.hub_logout_sfx, 'hub logout SFX');
  const logoutVO = new Audio(audio.hub_logout[localization], 'hub logout VO');

  const playAudio = () => {
    logoutSfx.play();
    logoutVO.play();
  };

  const stopAudio = () => {
    logoutSfx.stop();
    logoutVO.stop();
  };

  useEffect(() => {
    playAudio();

    return () => {
      stopAudio();
    };
  }, []);

  const handleLogout = () => {
    stopAudio();
    onLogout();
  };

  const handleCancel = () => {
    stopAudio();
    onCancel();
  };

  return (
    <SessionModal
      header={localizedStrings.logOut}
      prompt={localizedStrings.modals.logOut.areYouSure}
      continueText={localizedStrings.modals.logOut.back}
      onLogout={handleLogout}
      onCancel={handleCancel}
      actionScope="map-logout-modal"
    />
  );
};

MapLogOutModal.propTypes = {
  onLogout: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default MapLogOutModal;
